import { injectable } from 'inversify';

import { HttpService } from '../http';

@injectable()
export class FilesService {
  constructor(private http: HttpService) {}

  /**
   * Скачать файл
   *
   * @param url - Адрес ресурса
   * @param withAuth - Флаг авторизации
   * @returns Объект с файлом и именем файла
   */
  async getFile(url: string, withAuth?: boolean) {
    const result = await this.http.getFile(url, {
      withSide: true,
      withAuth: withAuth,
    });

    return result;
  }
}
